// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__QQF1C","spinner":"Spinner_spinner__PUQtU"};